import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { OrganizationService } from '../_services/organization.service';
import { RoleService } from '../_services/role.service';

import { Organization } from '../_models/organization';
import { Role } from '../_models/role';

@Component({
  moduleId: module.id,
  selector: 'user-form',
  templateUrl: 'user.form.component.html'
})

export class UserFormComponent implements OnInit {
  @Output() onSubmit: EventEmitter<any> = new EventEmitter<any>();
  @Input() model: any = {};
  @Input() loading: boolean;
  organizations: Array<Organization>;
  roles: Array<Role>;

  constructor(
    private roleService: RoleService,
    private organizationService: OrganizationService
  ){}

  ngOnInit() {
    Promise.all<Organization[], Role[]>([this.organizationService.getAll(), this.roleService.getAll()])
      .then(([orgs, roles]) => {
        this.organizations = orgs;
        this.roles = roles;
      });
  }

  submit() {
    this.onSubmit.emit(this.model);
  }

}



// WEBPACK FOOTER //
// ./src/app/users/user.form.component.ts